import 'intersection-observer';

import { cookieBar } from './cookie-bar/cookieBar';
import { accordion } from "./accordion/accordion";
import { form } from "./form/form";
import { collapsable } from "./collapsable/collapsable";
import { fancySelect } from "./fancy-select/fancySelect";
import { reportWizard } from "./report-wizard/reportWizard";
import {scrollLink} from "./scroll-link/scrollLink";
import {stick} from "./stick/stick";
import {knowledgeBase} from "./knowledge-base/knowledgeBase";
import { focusOnInput } from "./focus-on-input/focus-on-input";

window.addEventListener('DOMContentLoaded', (): void => {
    cookieBar();
    accordion();
    form();
    collapsable();
    fancySelect();
    reportWizard();
    scrollLink();
    knowledgeBase();
    stick();
    focusOnInput();
});
